module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_JP.872fc7aa.txt";